import * as React from "react"
import Svg, { Path } from "react-native-svg"

function SvgComponent({color = '#000', props}: any) {
  return (
    <Svg
      width={70}
      height={70}
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M60.926 66.161h.05v-55.79a6.54 6.54 0 00-6.532-6.532H15.555a6.54 6.54 0 00-6.531 6.531v55.791H60.926zm-10.32-49.31v-.05H32.356V19.495h18.248v-2.642zm0 15.556v-.05H32.356V35.05h18.248v-2.643zm0 15.556v-.05H32.356V50.606h18.248v-2.643zM27.221 22.087h.05V14.209H19.394V22.087H27.222zm0 15.556h.05V29.765H19.394V37.643H27.222zm0 15.555h.05V45.32H19.394V53.198H27.222zm31.061 10.27H11.716V10.37a3.844 3.844 0 013.84-3.839h38.888a3.844 3.844 0 013.839 3.84v53.098zM24.579 19.395h-2.492v-2.492h2.492v2.492zm0 15.556h-2.492v-2.493h2.492v2.493zm0 15.556h-2.492v-2.493h2.492v2.493z"
        fill={color}
        stroke={color}
        strokeWidth={0.1}
      />
    </Svg>
  )
}

export default SvgComponent
